import { writable, get } from "svelte/store";
import { APP_STATES } from "../models/app-states.enum";
function createAppStates() {
    // Init
    const store = writable(APP_STATES.INIT);
    const { subscribe, set, update } = store;
    // My store
    return {
        subscribe,
        hasNext: () => {
            const val = get(store);
            return val !== APP_STATES.END;
        },
        next: () => update((n) => {
            if (n !== APP_STATES.END) {
                n++;
            }
            return n;
        }),
        hasPrevious: () => {
            const val = get(store);
            return val !== APP_STATES.INIT;
        },
        previous: () => update((n) => {
            if (n !== APP_STATES.INIT) {
                n--;
            }
            return n;
        }),
        reset: () => set(APP_STATES.INIT),
    };
}
export const appstates = createAppStates();
